import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import SignUpForm from "../../../pages/ExtraPages/SignUp/SignUpForm";
import VerifyEmail from "../../../pages/ExtraPages/SignUp/VerifyEmail";
import {
  authKey_local_storage_key,
  last_logged_in_username_key,
} from "../../common";
import VerifyMobile from "../VerifyMobile";

const SignupPopup = () => {
  const [modalOpened, setModalOpened] = useState(false);

  const initial_state = {
    name: "",
    email: "",
    mobilenumber: "",
    password: "",
    confirmPassword: "",
    customerType: 0,
  };
  const [formData, setFormData] = useState(initial_state);
  const [showEmailVerify, setShowVerifyEmail] = useState(false);

  const [tab, setTab] = React.useState(0);
  const changeTab = (tab) => {
    setTab(tab);
    setFormData({ ...formData, customerType: tab });
  };

  const togglePopup = () => setModalOpened(!modalOpened);

  useEffect(() => {
    const username = localStorage.getItem(last_logged_in_username_key);
    const auth = localStorage.getItem(authKey_local_storage_key);

    console.log("🔐 username:", username);
    console.log("🔐 auth:", auth);

    if (!auth) {
      console.log("⏳ Opening popup in 12 sec...");
      setTimeout(() => {
        console.log("✅ Opening modal now");
        setModalOpened(true);
      }, 100000);
    } else {
      console.log("🚫 Popup blocked (user logged in)");
    }
  }, []);

  return (
    <div
      className="modal fade"
      id="applyNow"
      tabIndex="-1"
      aria-labelledby="applyNow"
      aria-hidden="true"
    >
      <Modal
        isOpen={modalOpened}
        toggle={togglePopup}
        centered
        className="signup-popup-dialog"
      >
        <ModalBody className="modal-body p-0 auth-box text-white pt-3">
          <div className="position-absolute end-0 top-0 p-3">
            <button
              type="button"
              className="btn-close text-white"
              data-bs-dismiss="modal"
              aria-label="Close"
              style={{ filter: "brightness(0) invert(1)" }}
              onClick={togglePopup}
            ></button>
          </div>

          {showEmailVerify ? (
            <div className="auth-content p-2 py-5 h-100">
              <VerifyMobile
                formData={formData}
                onVerifyEmailSuccess={() => {
                  setModalOpened(false);
                  setShowVerifyEmail(false);
                }}
              />
            </div>
          ) : (
            <div className="auth-content p-4 h-100">
              <div className="text-center">
                <h5>Find Jobs. Hire Talent. Grow Faster.</h5>
                <p>Sign up on Webvi and unlock endless opportunities.</p>
              </div>

              <div className="w-100 mt-3">
                <label className="form-label">Choose Type</label>
                <select
                  className="form-select"
                  value={formData.customerType ?? ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      customerType: parseInt(e.target.value),
                    })
                  }
                >
                  <option value="">Select Type</option>
                  <option value="0">Candidate</option>
                  <option value="1">Employer</option>
                </select>
              </div>

              <SignUpForm
                formData={formData}
                setFormData={setFormData}
                setShowVerifyEmail={setShowVerifyEmail}
              />
            </div>
          )}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default SignupPopup;
